// The 50 states + DC + Puerto Rico — exactly the jurisdictions the providers
// API can resolve to a place centroid (the Census Places gazetteer it keys on
// covers only these). Mirrors STATE_NAME_TO_CODE in
// apps/atlas-mcp/src/core/parse-search-location.ts, which is server-only and
// can't be imported here. The remaining US territories (GU, VI, AS, MP) are
// intentionally absent: a search there would parse but never resolve, so it
// belongs in the "outside coverage" bucket alongside a foreign subdivision.
export const US_REGION_CODES = new Set([
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
])

// `region` arrives lowercase from parseLocationSlug (slugify lowercases), and
// uppercase from CloudFront's `cloudfront-viewer-country-region`, so normalise
// before the lookup.
export const isUsRegionCode = (region: string): boolean => US_REGION_CODES.has(region.trim().toUpperCase())
